import PersonaScreen from "./PersonaScreen";

/** Legend (client) view — placeholder per ADR 0007. */
export default function LegendScreen({ onLogout }: { onLogout: () => void }) {
  return (
    <PersonaScreen
      title="Legends · Legend"
      copy="Run your caves: shows, tickets, take."
      onLogout={onLogout}
    />
  );
}
